import React from "react";
import { Badge2 } from "@/ui2/atoms/Badge";

import { getAppointmentFromDate, getTodaysDate } from "./helpers";

export const TodaysDateBadge = () => {
  const date = getTodaysDate();
  const appointmentDate = getAppointmentFromDate(date);

  return (
    <div className="tw:order-1 tw:flex tw:flex-col tw:gap-1 tw:lg:order-none tw:lg:flex-row tw:lg:items-center">
      <span className="body-xs tw:mr-1 tw:text-text-tertiary">Today&apos;s Date:</span>

      <Badge2 className="tw:whitespace-nowrap">
        <time
          dateTime={date.toISOString()}
        >{`${appointmentDate.day_of_week}, ${appointmentDate.month_of_year} ${appointmentDate.day}, ${appointmentDate.year}`}</time>
      </Badge2>
    </div>
  );
};
